// extracted by mini-css-extract-plugin
export default {"Container":"styles_Container__2gKIZ","Content":"styles_Content__C11sx"};